import React,{Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import MenuBarComponent from '../MenuBar/MenuBarComponent';
import styles from './Dashboard.less';
import MarginComponent from '../Margin/MarginComponent';
import TradePanelComponent from '../TradePanel/TradePanelComponent';
import ChartComponent from '../Chart/ChartComponent';
import ReportComponent from '../Report/ReportComponent';
import DeliveryComponent from '../Delivery/DeliveryComponent'
import Version from '../MenuBar/Version';
import LayoutComponent from '../LayoutComponent/LayoutComponent';
import StaticPanelComponent from './StaticPanelComponent';
import InstrumentListComponent from '../InstrumentList/InstrumentListComponent';
import TradeActivityComponent from '../TradeActivityComponent/TradeActivityComponent';
import AlertComponent from '../AlertComponent/AlertComponent';
import { Responsive, WidthProvider as widthProvider } from './../../components/Dashboard/index.js';
import * as dashboardActions from './../../actions/dashboardActions';
import * as commonActions from './../../actions/commonActions';
import * as marginActions from './../../actions/marginActions';
import * as newsFeedActions from './../../actions/newsFeedActions';
import * as activityActions from './../../actions/activityActions';
import * as instrumentListActions from './../../actions/instrumentListActions';
import * as tradepanelActions from './../../actions/tradepanelActions';
import * as reportActions from './../../actions/reportActions';
import * as chartActions from './../../actions/chartActions';
import * as tradeBookActions from './../../actions/tradeBookActions';
import light from './../../components/HoverTable/styles/light';
import {isLoaded as isAuthLoaded, load as loadAuth, logout, killSeesionlogout,closeForceLogout} from './../../redux/modules/auth';
import { push } from 'react-router-redux';
import Modal from 'react-modal';
const ResponsiveReactGridLayout = widthProvider(Responsive);
import NotificationSystem from 'react-notification-system';
import i18next from 'i18next';
import i18nextXHRBackend from 'i18next-xhr-backend';
import { applyStyle,applyToHover, setDirection, setThemedLogo } from './../../utils/utils';
import MUIIcon from '../../components/IconMaterialUI/MUIIcon';
const elementsData = [
  {"classNames":"responsiveReactGridLayout","elementType":"normal", "applyTo":"single" , "tagNames":"div"},
  {"classNames":"react-grid-item","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"lmtModal","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"mdlWrap","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"header","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"msg","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"closeBtn", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"notification-visible","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"notification-success","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"notification","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"notification-dismiss","elementType":"normal", "applyTo":"all", "tagNames":"span"},
  {"classNames":"notifyMsg","elementType":"normal", "applyTo":"all" , "tagNames":"p"},
  {"classNames":"caret","elementType":"normal", "applyTo":"all", "tagNames":"div"},
];
const directionData=[
  {"classNames":"caret","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"trdMeasureDrpDown","elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"dropdown-menu","elementType":"normal", "applyTo":"all", "tagNames":"ul"},
  {"classNames":"profileWrpDiv","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"closeIcon","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"notification-dismiss","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"notification-success","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"notification-message","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"notificationLabel","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"notifyMsg","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"eventTimeMsg","elementType":"normal", "applyTo":"all", "tagNames":"div"}
];
let evt = '';
let cnt = 0;

@connect(
  state => ({
  isInitialApiLoaded: state.dashboardRoot.dashboardReducer.isInitialApiLoaded, 
  userDetail:state.auth.userDetail,
  dashboardWidgets: state.dashboardRoot.dashboardReducer.dashboardWidgets,
  deleteWidgetKey: state.dashboardRoot.dashboardReducer.deleteWidgetKey,
  layout: state.dashboardRoot.dashboardReducer.layout,
  layoutWindow: state.dashboardRoot.dashboardReducer.layoutWindow,
  socketData: state.dashboardRoot.instrumentListReducer.socketData,
  lmtFillModExpObj:state.dashboardRoot.activityReducer.lmtFillModExpObj,
  navigationStatus: state.dashboardRoot.commonReducer.navigationStatus,
  killSession:state.dashboardRoot.commonReducer.killSession,
  loadTempFlag:state.dashboardRoot.dashboardReducer.loadTempFlag,
  loadTemplateFlag:state.dashboardRoot.dashboardReducer.loadTemplateFlag,
  setLockState:state.dashboardRoot.commonReducer.setLockState,
  language:state.dashboardRoot.commonReducer.language,
  marginHeight:state.dashboardRoot.dashboardReducer.marginHeight,
  marginWidth:state.dashboardRoot.dashboardReducer.marginWidth,
  instrumentListWidth:state.dashboardRoot.dashboardReducer.instrumentListWidth,
  instrumentListHeight:state.dashboardRoot.dashboardReducer.instrumentListHeight,
  tradebookWidth:state.dashboardRoot.dashboardReducer.tradebookWidth,
  tradebookHeight:state.dashboardRoot.dashboardReducer.tradebookHeight,
  chartHeight:state.dashboardRoot.dashboardReducer.chartHeight,
  chartWidth:state.dashboardRoot.dashboardReducer.chartWidth,
  trdHeight:state.dashboardRoot.dashboardReducer.trdHeight,
  trdWidth:state.dashboardRoot.dashboardReducer.trdWidth,
  trdkey:state.dashboardRoot.dashboardReducer.trdkey,
  chartkey:state.dashboardRoot.dashboardReducer.chartkey,
  tradebookkey:state.dashboardRoot.dashboardReducer.tradebookkey,
  tradePanelRandomNo:state.dashboardRoot.dashboardReducer.tradePanelRandomNo,
  chartRandomNo:state.dashboardRoot.dashboardReducer.chartRandomNo,
  trdBookRandomNo:state.dashboardRoot.dashboardReducer.trdBookRandomNo,
  TCO:state.dashboardRoot.instrumentListReducer.TCO,
  AccChange:state.dashboardRoot.instrumentListReducer.AccChange,
  selectedCssColor:state.dashboardRoot.commonReducer.selectedCssColor,
  // selectedCssColorTheme:state.dashboardRoot.commonReducer.selectedCssColorTheme,
  alertWindow:state.dashboardRoot.tradepanelReducer.alertWindow,
  ordersCTID:state.dashboardRoot.activityReducer.ordersCTID,
  ordcnfrmsg:state.dashboardRoot.activityReducer.ordcnfrmsg,
  requestRejectModal:state.dashboardRoot.activityReducer.requestRejectModal,
  deletewidgetflag:state.dashboardRoot.dashboardReducer.deletewidgetflag,
  unlockScreenFlag:state.dashboardRoot.commonReducer.unlockScreenFlag,
  checkLockFlag:state.dashboardRoot.commonReducer.checkLockFlag,
  tradeWidgetCnt:state.dashboardRoot.dashboardReducer.tradeWidgetCnt,
  dealFlag:state.dashboardRoot.activityReducer.dealFlag,
  selectedTheme:state.auth.selectedTheme,
  //allCssColorThemeData:state.dashboardRoot.commonReducer.allCssColorThemeData,
  allLangDirectionData:state.dashboardRoot.commonReducer.allLangDirectionData,
  orderSelectionFlag:state.dashboardRoot.activityReducer.orderSelectionFlag,
  configInfo:state.auth.configInfo,
  dealerSelectionFlag:state.dashboardRoot.activityReducer.dealerSelectionFlag,
  selectedLang:state.dashboardRoot.commonReducer.selectedLang,
  language:state.dashboardRoot.commonReducer.language,
  fixingNotifyObj:state.dashboardRoot.activityReducer.fixingNotifyObj,
  invalidCheck:state.dashboardRoot.activityReducer.invalidCheck,
  DFA:state.auth.DFA,
  }),
  {pushState: push,killSeesionlogout,logout,closeForceLogout,
    ...dashboardActions, ...commonActions, ...instrumentListActions, ...tradepanelActions, ...reportActions, ...chartActions,...marginActions,...tradeBookActions, ...activityActions, ...newsFeedActions
    })
export default class DashboardComponent extends Component {

  static propTypes = {
    dashboardWidgets: PropTypes.array,
    setSessionKillFlag:PropTypes.func,
    changeWidgetlayout: PropTypes.func,
	  layoutChanged: PropTypes.func,
    deleteWidgetKey: PropTypes.array,
    loadSocketData: PropTypes.func.isRequired,
    closeSocketData: PropTypes.func.isRequired,
    closeSocketTrade: PropTypes.func.isRequired,
    socketData: PropTypes.array,
    editDashboard: PropTypes.func.isRequired,
    navigationStatus: PropTypes.string,
    loadSocketTradeData: PropTypes.func.isRequired,
    loadNewsFeedComponent:PropTypes.func,
    killSeesionlogout: PropTypes.func.isRequired,
    logout:PropTypes.func.isRequired,
    pushState: PropTypes.func,
    resetState: PropTypes.func.isRequired,
    adduserLogInActivity : PropTypes.func.isRequired,
    loadTempFlag:PropTypes.bool,
    loadTemplateFlag: PropTypes.func,
    closeForceLogout: PropTypes.func.isRequired,
    setLockState:PropTypes.bool,
    TCO: PropTypes.object,
    loadAccBalMargin:PropTypes.func.isRequired,
    loadNoMrgAccBalMargin:PropTypes.func.isRequired,
    resizeInstrumentList:PropTypes.func.isRequired,
    resizeMargin:PropTypes.func.isRequired,
    resizeTradePanel:PropTypes.func.isRequired,
    resizeTradebook:PropTypes.func.isRequired,
    resizeChart:PropTypes.func.isRequired,
    ordersCTID:PropTypes.array,
    ordcnfrmsg:PropTypes.object,
    closeOrdConfirmMsg:PropTypes.func,
    requestRejectModal:PropTypes.object,
    deletewidgetflag:PropTypes.bool,
    unlockScreenFlag:PropTypes.bool,
    setUnlockModal:PropTypes.func,
    checkLockFlag:PropTypes.bool,
    checkLockStatus:PropTypes.func,
    tradeCnt:PropTypes.func,
    handleModal: PropTypes.func,
    setLogoutFlag:PropTypes.func,
    setLayoutFlag:PropTypes.func,
    dealFlag:PropTypes.bool,
    closeDealFailedModal:PropTypes.func,
    selectedCssColor:PropTypes.string,
    // selectedCssColorTheme:PropTypes.object,
    //allCssColorThemeData:PropTypes.object,
    allLangDirectionData:PropTypes.object,
    orderSelectionFlag:PropTypes.bool,
    configInfo:PropTypes.object,
    dealerSelectionFlag:PropTypes.bool,
    getMarkup:PropTypes.func,
    getVersionDetails:PropTypes.func,
    getFixingDetails:PropTypes.func,
    getAllFixingEvents:PropTypes.func,
    getValidFixingEvents:PropTypes.func,
    isAllApiLoaded : PropTypes.func
  }
	state = {
    deleteWidgetKey:[],
    lmtCnfrmMsgBoxFlag:false,
    // selectedCssColorTheme:{},
	}
  constructor() {
     super();
     this.onResize = this.onResize.bind(this);
     this.onLayoutChange = this.onLayoutChange.bind(this);
     this.afterOpenModal = this.afterOpenModal.bind(this);
  }
  componentDidUpdate(preProps){
    const thisComponent = ReactDOM.findDOMNode(this);
   // //const allCssStyleRules = this.props.selectedCssColorTheme;
    //applyStyle(thisComponent, allCssStyleRules, elementsData);
    setDirection(thisComponent,directionData,this.props.selectedLang);
   }
 componentWillMount(){
   this.props.getAllColors();
   this.props.setTheme(this.props.selectedTheme);
    const env = this.props.configInfo && this.props.configInfo.isProd === false ? 'dev' : 'production';
  // this.props.setSelectedCssTheme(this.props.allCssColorThemeData[this.props.selectedTheme]);
   if(i18next.exists('margin')==undefined){
     i18next
     .use(i18nextXHRBackend)
     .init({
       lng: this.props.userDetail.LN,
       wait: true,
       fallbackLng: this.props.userDetail.LN,
       // ns: ['en', 'fr', 'nl'],
       // defaultNS: 'en',
       // debug: true,
       initImmediate: false,
       backend: {
         loadPath: `https://neox-asset.neofinancials.com/ntp/${env}/locales/{{lng}}.json`,
         crossDomain: true
       }
     }, function(err, t) {
       // init set content
     });
    }
    i18next.changeLanguage(this.props.userDetail.LN, (err, t) => {
        if (err) return console.log('something went wrong loading', err);
        this.props.changeLanguage(this.props.userDetail.LN);
    });
    if (this.props.userDetail.LN === 'AR') {
      this.props.setSelectedLangJson(this.props.allLangDirectionData[this.props.userDetail.LN]);
    }
    else {
      this.props.setSelectedLangJson(this.props.allLangDirectionData['notAR']);
    }
   }

  componentDidMount() {
    const thisComponent = ReactDOM.findDOMNode(this);
    ////const allCssStyleRules = this.props.selectedCssColorTheme;
    //applyStyle(thisComponent, allCssStyleRules, elementsData);
    setDirection(thisComponent,directionData,this.props.selectedLang);
    
    if(this.props.configInfo && this.props.configInfo?.locationDesc){
      const LOCATION = this.props.configInfo?.locationDesc;
      const env = this.props.configInfo.isProd === false ? 'dev' : 'production';
      const faviconUrl = `https://neox-asset.neofinancials.com/ntp/${env}/${LOCATION}/favicon.png`;

      let link = document.querySelector("link[rel*='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'shortcut icon';
        document.head.appendChild(link);
      }
      link.href = faviconUrl;
    }

    // light.cell = allCssStyleRules.cell;
    //light.dimensions = allCssStyleRules.dimensions;
    var cnt=0;
    let mrgWidgetHeight;
    this.props.layout.map((item) => {
      let str = item.i;
      str = str.substring(0, str.indexOf('-'));
      switch (str) {
        case 'Instrument':
          this.props.resizeInstrumentList(item.h,item.w);
          break;
        case 'Margin':
        if(this.props.userDetail.newRiskCheckType==="MT_NoMrg" ||(this.props.userDetail.newRiskCheckType=="MT_AsPerAcc" && this.props.DFA.MT==="MT_NoMrg")){
            mrgWidgetHeight=2;
          } else {
            mrgWidgetHeight=item.h
          }
          this.props.resizeMargin(mrgWidgetHeight,item.w);
          break;
        case 'Trade':
          item.name = 'Trade';
          this.props.resizeTradePanel(item.h,item.w);
          cnt++;
          break;
        case 'TradeActivityBook':
          this.props.resizeTradebook(item.h,item.w,item.i);
          this.props.setRefreshFlag(true,item.i);
          break;
        case 'Chart':
          this.props.resizeChart(item.h,item.w,item.i);
          break;
        default:
          break;
      }
    });
    this.props.tradeCnt(cnt);
    (function () {

      if ( typeof window.CustomEvent === "function" ) return false;

      function CustomEvent ( event, params ) {
        params = params || { bubbles: false, cancelable: false, detail: undefined };
        var evt = document.createEvent( 'CustomEvent' );
        evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
        return evt;
       }

      CustomEvent.prototype = window.Event.prototype;

      window.CustomEvent = CustomEvent;
    })();



    // evt = window.document.createEvent('UIEvents');
    // evt.initUIEvent('resize', true, false, window, 0);
    evt = new CustomEvent('onresize');

  //  this.setState({lang:this.props.userDetail.LN});
    this.setState({deleteWidgetKey:this.props.deleteWidgetKey});
    this.displayNotificationSystem = this.refs.notificationSystem;
      this.props.loadSocketData();
      this.props.loadNewsFeedComponent();
      this.props.adduserLogInActivity();
      this.props.loadSocketTradeData();
      this.props.getAllOrdersTrd(JSON.parse(localStorage.getItem('DFA')).C);
      this.props.setTheme(this.props.selectedTheme);
      this.props.getMarkup();
      this.props.getVersionDetails();
      this.props.getAllFixingEvents();
      //this.props.getTrdBook();
      //this.props.getOrderBook();
      var layout = { lg: this.props.layout, md:this.props.layout, sm:this.props.layout  };
      if(window.innerWidth >= 1300){
        layout = { lg: this.props.layoutWindow, md:this.props.layoutWindow, sm:this.props.layoutWindow };
      }
      /*window.addEventListener('storage', () => {
        console.log("window.addEventListener");
        if(localStorage.getItem('windowForcedLogin')==='true'){
          this.props.killSessionTrader("Your Session has been terminated.",false);
        }else if(localStorage.getItem('windowForcedLogin')===null||localStorage.getItem('windowForcedLogin')==="clear"){
				this.props.closeforcedModal();
				this.props.closeSocketData();
				this.props.closeSocketTrade();
				this.props.resetState();
				this.props.loadTemplateFlag(false);
				localStorage.setItem('logoutClose',true);
				this.props.clearHeartRateInterval();
				this.props.clearHeartOrdInterval();
				//  this.props.resetStateSocket();
          this.props.pushState('/login');
				if(localStorage.getItem('user')!==null && localStorage.getItem('user')!=='null'){
        this.props.logout(this.props.userDetail);
        return;
        }
		    }
      });*/
      window.addEventListener('storage', (event) => {
        if(event.key === "windowForcedLogin"){
          if(event.newValue === "true"){
            this.props.killSessionTrader(i18next.t("sessionTerminateMsg"),false);
          }else if(event.newValue === null || event.newValue === "clear"){
            this.props.closeforcedModal();
            this.props.closeSocketData();
            this.props.closeSocketTrade();
            this.props.resetState();
            this.props.loadTemplateFlag(false);
            localStorage.setItem('logoutClose',true);
            this.props.clearHeartRateInterval();
            this.props.clearHeartOrdInterval();
            this.props.isAllApiLoaded(false);
            this.props.pushState('/login');
            if(localStorage.getItem('user')!==null || localStorage.getItem('user') !== 'null'){
              this.props.logout(this.props.userDetail);
            }
          }
        }
      });
      this.setState({ layout: layout });
      window.addEventListener('resize', () => {
        var layout = { lg: this.props.layoutWindow, md:this.props.layoutWindow, sm:this.props.layoutWindow };
        if(window.innerWidth >= 900  ){
          layout = { lg: this.props.layoutWindow, md:this.props.layoutWindow, sm:this.props.layoutWindow };
          this.setState({ layout: layout });
        }
        this.setState({ layout: layout });
        cnt++;
        this.props.loadTemplateFlag(true);
      });
      this.props.loadTemplateFlag(true);
  }

  onResize() {
       //this.forceUpdate();
   }

  componentWillReceiveProps(nextProps,nextState){
    if(this.props.selectedCssColor !== nextProps.selectedCssColor){
      this.props.setTheme(nextProps.selectedCssColor);
      //this.props.setSelectedCssTheme(this.props.allCssColorThemeData[nextProps.selectedCssColor]);
    }
    if (this.props.language !== nextProps.language) {
      if (nextProps.language === 'AR') {
        this.props.setSelectedLangJson(this.props.allLangDirectionData[nextProps.language]);
      }
      else {
        this.props.setSelectedLangJson(this.props.allLangDirectionData['notAR']);
      }
    }
    if (this.props.selectedLang !== nextProps.selectedLang) {
      const thisComponent = ReactDOM.findDOMNode(this);
      setDirection(ReactDOM.findDOMNode(this),directionData,nextProps.selectedLang);
    }
    // if(this.props.selectedCssColorTheme !== nextProps.selectedCssColorTheme){
    //   const thisComponent = ReactDOM.findDOMNode(this);
    //   const allCssStyleRules = nextProps.selectedCssColorTheme;
    //   //applyStyle(thisComponent, allCssStyleRules, elementsData);
    //   light.cell = allCssStyleRules.cell;
    //   light.dimensions = allCssStyleRules.dimensions;
    // }
    if(this.props.deletewidgetflag !== nextProps.deletewidgetflag){ // checked deletwidgetflag condition to solve white screen issue on delete widget
      this.setState({deleteWidgetKey:nextProps.deleteWidgetKey});
      const {deleteWidgetKey, layout} = nextProps;
      const layoutArray = layout;
      if (deleteWidgetKey && layoutArray) {
        deleteWidgetKey.forEach((item) => {
          layoutArray.forEach((element, index) => {
            if (item === element.i) {
              layoutArray.splice(index, 1);
            }
          });
        });
      }
      this.props.changeWidgetlayout(nextProps.dashboardWidgets,layoutArray, deleteWidgetKey,'DASH');
    }
    if((this.props.marginWidth !== nextProps.marginWidth)||(this.props.marginHeight !== nextProps.marginHeight)
    ||(this.props.instrumentListWidth!==nextProps.instrumentListWidth)||(this.props.instrumentListHeight!==nextProps.instrumentListHeight)
    ||(this.props.tradebookHeight!==nextProps.tradebookHeight)||(this.props.tradebookWidth!==nextProps.tradebookWidth)
    ||(this.props.chartHeight!==nextProps.chartHeight)||(this.props.chartWidth!==nextProps.chartWidth)
    ||(this.props.tradePanelRandomNo!==nextProps.tradePanelRandomNo)||(this.props.trdBookRandomNo!==nextProps.trdBookRandomNo)
    ||(this.props.chartRandomNo!==nextProps.chartRandomNo)){
      this.props.layoutChanged(1);
      this.props.changeWidgetlayout(nextProps.dashboardWidgets, nextProps.layout, nextProps.deleteWidgetKey,'DASH');
       try {
          window.dispatchEvent(evt);
        } catch(e) {
          console.log("e "+e);
        }
    }
     if(this.props.lmtFillModExpObj !== nextProps.lmtFillModExpObj){
      if(nextProps.lmtFillModExpObj.title !== ''){
         this.displayNotification(nextProps.lmtFillModExpObj,nextProps.dealerSelectionFlag);
         if(this.props.lmtFillModExpObj === nextProps.lmtFillModExpObj){
           this.props.closeBMAlert(this.props.lmtFillModExpObj);
         }
      }
     }
     if(this.props.fixingNotifyObj !== nextProps.fixingNotifyObj){
      if(nextProps.fixingNotifyObj.title !== ''){
         this.displayNotification(nextProps.fixingNotifyObj,nextProps.dealerSelectionFlag);
         if(this.props.fixingNotifyObj === nextProps.fixingNotifyObj){
           this.props.closeBMAlert(this.props.fixingNotifyObj);
         }
      }
     }
     if(this.props.loadTempFlag === true){
       if(this.props.layout !== nextProps.layout){
         //this.forceUpdate();
         var layout = { lg: nextProps.layout , md:nextProps.layout, sm:nextProps.layout};
          if(window.innerWidth >= 1300){
            layout = { lg: nextProps.layoutWindow, md:nextProps.layoutWindow, sm:nextProps.layoutWindow };
            this.setState({ layout: layout});
          }
          this.setState({ layout: layout});
        }
         this.props.changeWidgetlayout(nextProps.dashboardWidgets, nextProps.layout, nextProps.deleteWidgetKey,'DASH');
      }
     if(this.props.AccChange!==nextProps.AccChange){
    	 if(nextProps.AccChange){
         if(this.props.userDetail.newRiskCheckType==="MT_NoMrg" ||(this.props.userDetail.newRiskCheckType=="MT_AsPerAcc" && this.props.DFA.MT==="MT_NoMrg")){
           this.props.loadNoMrgAccBalMargin(JSON.parse(localStorage.getItem("DFA")).C)
         } else{
           this.props.loadAccBalMargin(JSON.parse(localStorage.getItem("DFA")).C,"trader",false)
         }
    		 }
     }
     if((this.props.ordcnfrmsg.CTID !== nextProps.ordcnfrmsg.CTID) && (nextProps.ordcnfrmsg.CTID !== '')){
       if(nextProps.ordersCTID.indexOf(nextProps.ordcnfrmsg.CTID) !== -1){
         if(nextProps.requestRejectModal.mdflag === false){
           this.setState({lmtCnfrmMsgBoxFlag :true});
         }
       }
     }
    }
    //Close Limit confirmation
    closeLmtCnfrmModal=()=>{
      try{
        this.setState({lmtCnfrmMsgBoxFlag: false});
        this.props.closeOrdConfirmMsg();
      }catch(e){
        this.props.logFileCreation({error:e.message, originFunction:'closeLmtCnfrmModal', component:"DashboardComponent"});
      }
    }

  componentWillUnmount() {
	  this.props.editDashboard(false);
    this.props.closeSocketData();
    this.props.closeSocketTrade();
  }

  onLayoutChange = (layout) => {
    try{
      let marginHeightCheck;
      if(this.props.userDetail.newRiskCheckType==="MT_NoMrg" || (this.props.userDetail.newRiskCheckType==="MT_AsPerAcc" && this.props.DFA.MT==="MT_NoMrg")){
          marginHeightCheck=2;
        }  else {
          marginHeightCheck=this.props.marginHeight
        }

      layout.map((item) => {
        let str = item.i;
        str = str.substring(0, str.indexOf('-'));
        switch (str) {
          case 'Instrument':
            item.name = 'InstrumentList';
            item.w=this.props.instrumentListWidth;
            item.h=this.props.instrumentListHeight;
            item.minW=1;
            item.maxW=5;
            item.minH=1;
            item.maxH=5;
            break;
          case 'Margin':
            item.name = 'Margin';
            item.w=this.props.marginWidth;
            item.h= marginHeightCheck;
            item.minW=1;
            item.maxW=1;
            item.minH=1;
            item.maxH=2;
            break;
          case 'Trade':
            item.name = 'Trade';
            if(item.i == this.props.trdkey){
              item.w=this.props.trdWidth;
              item.h=this.props.trdHeight;
            }else{
              item.w=item.w;
              item.h=item.h;
            }
            item.minW=1;
            item.maxW=5;
            item.minH=2;
            item.maxH=2;
            if(item.cmdtyPair===""){
              const tco=this.props.TCO;
              item.cmdtyPair=tco[0];
            }
            if(item.selectedTabKey !==undefined){
              item.selectedTabKey=item.selectedTabKey;
            }
            break;
          case 'TradeActivityBook':
            if(item.i == this.props.tradebookkey){
              item.w=this.props.tradebookWidth;
              item.h=this.props.tradebookHeight;
            }else{
              item.w=item.w;
              item.h=item.h;
            }
            item.minW=3;
            item.maxW=5;
            item.minH=1;
            item.maxH=5;
            item.name = 'TradeActivityBook';
            break;
          case 'Chart':
            if(item.i == this.props.chartkey){
              item.w=this.props.chartWidth;
              item.h=this.props.chartHeight;
            }else{
              item.w=item.w;
              item.h=item.h;
            }
            item.minW=2;
            item.maxW=2;
            item.minH=2;
            item.maxH=2;
            item.name = 'Chart';
            break;
          default:
            break;
        }
      });
      this.props.layoutChanged(1);
      this.props.changeWidgetlayout(this.props.dashboardWidgets, layout, this.props.deleteWidgetKey,'DASH');
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onLayoutChange', component:"DashboardComponent"});
    }
  }

  onBreakpointChange = () => {
  }

  onCloseDealFailedModal =(event)=>{
    try{
      this.props.loadSocketTradeData();
      this.props.closeDealFailedModal(false);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onCloseDealFailedModal', component:"DashboardComponent"});
    }
  }

  closekillSessionModal = () => {
    try{
      if(this.props.killSession.Flag==='true'){
        this.props.resetState();
        localStorage.setItem('logoutClose',true);
        this.props.logout(this.props.userDetail);
      }else{
        this.props.resetState();
        this.props.isAllApiLoaded(false);
        this.props.pushState('/login');
        localStorage.removeItem('user')
        setTimeout(() => {
          this.props.killSeesionlogout();
        }, 1000);
      }
        this.props.handleModal(false);
        this.props.setLogoutFlag(false);
        this.props.setLayoutFlag(false);
        this.props.closeForceLogout();
        this.props.setSessionKillFlag(false);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closekillSessionModal', component:"DashboardComponent"});
    }
  }

  closeInvalidCheckModal= () => {
    try{
      this.props.closeInvalidCheckModal();
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeInvalidCheckModal', component:"DashboardComponent"});
    }
  }

  displayNotification = (object,dealerSelectionFlag) =>{
    try{
      if(((this.props.orderSelectionFlag === true||dealerSelectionFlag===true) && object.eventType === "CANCELLED") || object.eventType ==="MODIFIED" || object.eventType ==="FILLED" || object.eventType ==="PARTIALLY FILLED" || object.eventType ==="EXPIRED"){
        this.displayNotificationSystem.addNotification({
          message: <div><label style={{fontSize: 14}}>{object.title +" "+"Order"} : &nbsp;</label>
                  <label className={
                    object.eventType ==="MODIFIED" ? `${styles.modifiedColor}` :
                    object.eventType ==="FILLED" ? `${styles.filledColor}` :
                    object.eventType ==="PARTIALLY FILLED" ? `${styles.filledColor}`:
                    `${styles.expiredColor}`}>      {`${object.eventType}`}</label></div>,
          autoDismiss:'0',
            level: 'success',
            position: this.props.language === 'AR'? 'tl':'tr',
            children: (
              <div>
                <div id="notifiMsgDiv" className={`${styles.BMmsgDiv}`}>
                  <div className={`${styles.BMmsgLabel}`}>
                    <label className={`${styles.label} notificationLabel`}>{i18next.t("eventTime")}: </label>
                    <p className="notifyMsg eventTimeMsg">{object.ts}</p>
                  </div>
                  {object.title === "Fixing" ?
                  <div className={`${styles.BMmsgLabel}`}>
                    <label className={`${styles.label} notificationLabel`}>{i18next.t("fixingEvent")}: </label>
                    <p className="notifyMsg">{object.fixingEvent}</p>
                  </div>:null}
                  <div className={`${styles.BMmsgLabel}`}>
                    <label className={`${styles.label} notificationLabel`}>{i18next.t("orderNo")}: </label>
                    <p className="notifyMsg">{object.docNo}</p>
                  </div>
                  {object.title === "Fixing" ?
                  <div className={`${styles.BMmsgLabel}`}>
                    <label className={`${styles.label} notificationLabel`}>{i18next.t("fixingDate")}: </label>
                      <p className="notifyMsg">{object.fixingDate}</p>
                  </div>:null}
                  {object.eventType === "FILLED" || object.eventType ==="PARTIALLY FILLED" ?
                    <div className={`${styles.BMmsgLabel}`}>
                      <label className={`${styles.label} notificationLabel`}>{i18next.t("docNo")}: </label>
                      <p className="notifyMsg">{object.fncNo}</p>
                    </div>
                    :
                    <div className={`${styles.BMmsgLabel}`}>
                      <label className={`${styles.label} notificationLabel`}>{i18next.t("user")}: </label>
                      <p className="notifyMsg">{object.trader}</p>
                    </div>
                  }
                  <div className={`${styles.BMmsgLabel} ${styles.commentWrap}`}>
                    <label className={`${styles.label} notificationLabel`}>{i18next.t("details")}: </label>
                    <div className={`${styles.commentsLabel}`}><p className="notifyMsg">{object.remark}</p></div>
                  </div>
                {object.remark2!==""?
                  <div className={`${styles.BMmsgLabel} ${styles.commentWrap}`}>
                  { object.eventType ==="PARTIALLY FILLED" ?
                    <label className={`${styles.label} notificationLabel`}>{i18next.t("pendingQty")}: </label>
                    :<label className={`${styles.label} notificationLabel`}>{i18next.t("olddetails")}: </label>}
                    <div className={`${styles.commentsLabel}`}><p className="notifyMsg">{object.remark2}</p></div>
                </div>:null}
                </div>
              </div>
            )
          });
        }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'displayNotification', component:"DashboardComponent"});
    }
  }

  handleDashboardDiv = () =>{
    try{
      if(this.props.checkLockFlag === true){
        clearTimeout(this.timer);
        this.props.setUnlockModal(true);
        this.timer = setTimeout(() => {
        this.props.setUnlockModal(false);
        }, 10000);
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'handleDashboardDiv', component:"DashboardComponent"});
    }
  }

  afterOpenModal() {
    try{
        const thisComponent = this.refs.errorMSG;
      // //const allCssStyleRules = this.props.selectedCssColorTheme;
        // const elementsData = [
        //   {"classNames":"header", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        //   {"classNames":"closeBtn", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        //   {"classNames":"warningModal", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
        //   {"classNames":"msg", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
        //   {"classNames":"mdlWrap", "elementType":"normal", "applyTo":"all", "tagNames":"div"}
        // ];
        // applyStyle(thisComponent, allCssStyleRules, elementsData);
        const directionData = [
          {"classNames":"header", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
          {"classNames":"commonCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
          {"classNames":"commonMsgDir", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
          {"classNames":"trdCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        ];
        setDirection(thisComponent,directionData,this.props.selectedLang);
        const hoverElementsClassNames = [
            {"elmToHover":thisComponent.getElementsByClassName("closeBtn")[0], "classNames":"closeBtn"}
            //{"elmToHover":thisComponent.getElementsByClassName('dropDownList')[0], "classNames":"dropDownList"}
        ];
      //  //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'afterOpenModal', component:"DashboardComponent"});
    }
  }

  render() {
    const { dashboardWidgets, navigationStatus } = this.props;
    let currentSelection = 'trade';
    if (typeof navigationStatus !== 'undefined') {
      currentSelection = navigationStatus;
    } else {
      return currentSelection;
    }
    const CloseIcon = <span className={`${styles.icon} closeIcon commonCloseIcon`}> <MUIIcon icon={'Close'} className="closeBtn trdCloseIcon"/></span>;
    const user = JSON.parse(localStorage.getItem('user'));
    //const ts = JSON.parse(localStorage.getItem('TS'));
    const style = {
      NotificationItem: {
        DefaultStyle: {
          margin: '10px 5px 2px 1px'
        },
      }
    };
    const opacity= {
      opacity:this.props.configInfo.logoOpacity
    }

    const LOCATION = this.props.configInfo.locationDesc
    const env = this.props.configInfo && this.props.configInfo.isProd === false ? 'dev' : 'production';

    return (
      <div id="dashBordDiv" onClick={this.handleDashboardDiv} className={`${this.props.language}`}>
        <div>{this.props.checkLockFlag === true ?
          <div id="lockScreenDiv" className={styles.lockScreenDiv} onClick={this.handleDashboardDiv}></div>:null}
        </div>
        <NotificationSystem ref="notificationSystem" style={{"background":"red"}}/>
          {this.props.alertWindow.flag === true ? <AlertComponent /> : null }
          <Modal isOpen={this.props.dealFlag==true} id="dealFailModal" className={styles.warningModal} overlayClassName="overlay" contentLabel="Example Modal" onAfterOpen={this.afterOpenModal}>
            <div ref="errorMSG" className="mdlWrap" >
              <div className={`${styles.header} header`}>
                <span className={styles.msgTitle}>{i18next.t("error")}</span>
              </div>
              <span onClick={this.onCloseDealFailedModal} className={`${styles.closeicon}`} id="closeModalIcon">{CloseIcon}</span>
              <div className={`${styles.msg} msg commonMsgDir`}>
                {i18next.t("trdRejectMsg")}
              </div>
            </div>
          </Modal>
          <Modal isOpen={this.props.killSession.Key} id="killSessModal" className={styles.warningModal} overlayClassName="overlay" contentLabel="Example Modal" onAfterOpen={this.afterOpenModal}>
            <div ref="errorMSG" className="mdlWrap" >
              <div className={`${styles.header} header`}>
                <span className={styles.msgTitle}>{i18next.t("logout")}</span>
              </div>
              <span onClick={this.closekillSessionModal} className={`${styles.closeicon}`} id="closeModalIcon">{CloseIcon}</span>
              <div className={`${styles.msg} msg commonMsgDir`}>
                {i18next.t(this.props.killSession.Msg)}
              </div>
            </div>
          </Modal>
          <Modal isOpen={this.props.invalidCheck.flag} id="dashWrngModal" className={styles.warningModal} overlayClassName="overlay" contentLabel="Example Modal" onAfterOpen={this.afterOpenModal}>
            <div ref="errorMSG" className="mdlWrap" >
              <div className={`${styles.header} header`}>
                <span className={styles.msgTitle}>{i18next.t("alert")}</span>
              </div>
              <span onClick={this.closeInvalidCheckModal} className={`${styles.closeicon}`} id="closeModalIcon">{CloseIcon}</span>
              <div className={`${styles.msg} msg commonMsgDir`}>
                {i18next.t(this.props.invalidCheck.Msg)}
              </div>
            </div>
          </Modal>
          <Modal isOpen={this.state.lmtCnfrmMsgBoxFlag} className={`${styles.lmtCnfrmMsgModal} lmtModal`}  id="lmtModal" onAfterOpen={this.afterOpenModal}>
            <div ref="errorMSG" className="mdlWrap" >
              <div className={`${styles.header} header`}>
                { this.props.ordcnfrmsg.headerTitle != "" ?
                <span className={`${styles.msgTitle}`}>{i18next.t(this.props.ordcnfrmsg.headerTitle)}</span>: null }
              </div>
              <span onClick={this.closeLmtCnfrmModal} className={`${styles.closeicon}`} id="closeModalIcon">{CloseIcon}</span>
              <div className={`${styles.cnfrnMsgDiv} msg commonMsgDir`} id="confirmationMsgDiv">
              { this.props.ordcnfrmsg.remark1 != "" ?
                <p>{this.props.ordcnfrmsg.remark1}</p> : null }
                { this.props.ordcnfrmsg.remark2 != "" ?
                  <p>{this.props.ordcnfrmsg.remark2}</p> : null }
              </div>
            </div>
          </Modal>
          {true ?
           <div id="responsiveReactGridLayout" className={this.props.checkLockFlag === true ? `${styles.setLockClass} responsiveReactGridLayout` : `${styles.setUnlockClass} responsiveReactGridLayout`}>
             <div className={`${styles.dragablePanelDiv}`}>
               {this.props.navigationStatus==='trade'?
               <div className="wtrMark">
                <img 
                    src={setThemedLogo(LOCATION, this.props.selectedTheme, env)}
                    onError={e => setThemedLogo(LOCATION, this.props.selectedTheme, env, 'dark', e)} 
                />
               </div>:null}
               <div className="wtrMarkOnTop" style={opacity}>
                <img 
                    src={setThemedLogo(LOCATION, this.props.selectedTheme, env)} 
                    onError={e => setThemedLogo(LOCATION, this.props.selectedTheme, env, 'dark', e)} 
                />
               </div>
               <ResponsiveReactGridLayout
                    className={'layout'+ (currentSelection !== 'trade' ? ` ${styles.invisible}`: '')}
                    draggableHandle='.widgetheader'
                     breakpoints={{lg: 1200, md: 900, sm: 600, xs: 300, xxs:100}}
                    cols={{lg: 5, md: 4, sm: 3, xs:2,xxs:2}}
                    gutter={{ lg: 1, md: 1, sm: 1, xs:1,xxs:1}}
                    onBreakpointChange={this.onBreakpointChange}
                    rowHeight={200}
                    data-width = {this.state.width}
                    layouts={this.state.layout}
                    onLayoutChange={this.onLayoutChange}
                    isResizable={false}
                    autoSize={true}
                    margin= {[10, 10]}
                    preventCollision={false}
                    useCSSTransforms={true}
                    id="dashBoardGrid">
                    {
                      dashboardWidgets && dashboardWidgets.map((item) => {
                       switch (item.name) {
                          case 'Chart':
                             return <div key={item.i} > {currentSelection !== 'report' && <ChartComponent props={this.state.language}  CloseIcon={CloseIcon} keyValue={item.i} width={item.w} height={item.h}/>} </div>;
                             break;
                          case 'Trade':
                             return <div key={item.i}> <TradePanelComponent props={this.props.language} clasName={`${styles.divZindex}`} CloseIcon={CloseIcon} keyValue={item.i} width={item.w} height={item.h} cmdtyPair={item.cmdtyPair} selectedTabKey={item.selectedTabKey} socketData={this.props.socketData}/></div>;
                             break;
                          case 'Margin':
                            return <div key={item.i}> <MarginComponent props={this.props.language} clasName="" CloseIcon={CloseIcon} keyValue={item.i} width={item.w} height={this.props.userDetail.newRiskCheckType==="MT_NoMrg" || (this.props.userDetail.newRiskCheckType==="MT_AsPerAcc" && this.props.DFA.MT ==="MT_NoMrg") ?  2 : item.h}/></div>;/*removed  this.props.userDetail.riskCheckType ? 1:*/
                            break;
                          case 'TradeActivityBook':
                             return <div key={item.i}> <TradeActivityComponent props={this.props.language} clasName="" CloseIcon={CloseIcon} keyValue={item.i} width={item.w} height={item.h}/></div>;
                             break;
                          case 'InstrumentList':
                              return <div key={item.i}> <InstrumentListComponent props={this.props.language} clasName=""  CloseIcon={CloseIcon} keyValue={item.i} width={item.w} height={item.h}/></div>;
                              break;
                          default:
                           // return null;
                            break;
                        }
                      })
                    }
              </ResponsiveReactGridLayout>
           </div>
           {/* <div className={'staticPanel'+ (currentSelection !== 'trade' ? ` ${styles.invisible}`: '')}>
             <StaticPanelComponent props={this.props.language}/>
           </div> */}
           </div>:null}
          { currentSelection === 'report' ?
            <div style={{position: 'inherit', top: '100px', left: 0, width:'100%'}}><ReportComponent/></div>
          :null}

          { currentSelection === 'delivery' ?
            <div style={{position: 'inherit', top: '100px', left: 0, width:'100%'}}><DeliveryComponent/></div>
          :null}

          { currentSelection === 'layout' ?
            <div style={{position: 'absolute', top: '100px', left: 0, width:'100%', background: '#e3e5e6'}}><LayoutComponent /></div>:null}

          { currentSelection === 'version' ?
             <div style={{position: 'inherit', top: '100px', left: 0, width:'100%'}}><Version/></div>
           :null}
       </div>

    );
  }
}
